import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { ArrowForwardIosSharp } from '@mui/icons-material';
import './RequestActivitiesTable.css';
import RequestActivityRow from '../RequestActivityRow/RequestActivityRow';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import Tooltip from '../../../../components/Tooltip';
import { RootState } from '../../../../shared/redux/store';
import AppFile from '../../../../models/AppFile';

const RequestActivitiesTable = ({
  editFiles,
  addFile,
  removeFile,
  isEditFile,
  getMaxSize,
}: {
  editFiles?: boolean,
  addFile?: (file: AppFile) => void,
  removeFile?: (documentID: string) => void,
  isEditFile?: boolean,
  getMaxSize?: (document: AppFile) => string,
}) => {

  const activities = useSelector((state: RootState) => state.requestSearch.searchRequest.equivalencies.activities);

  const [expandedAll, setExpandedAll] = useState(false);
  const [activitiesExpanded, setActivitiesExpanded] = useState([]);

  const handleChangeExpanded = () => {
    if (expandedAll) {
      collapseAllActivities();
    } else {
      expandedAllActivities();
    }
    setExpandedAll(!expandedAll);
  };

  const classNameArrowIcon = () => {
    return expandedAll ? 'expanded-all' : 'collapse-all';
  };

  const expandedAllActivities = () => {
    const activitiesArray = activities.map((a: { id: string; }) => a.id);
    setActivitiesExpanded(activitiesArray);
  };

  useEffect(() => {
    setTimeout(expandedAllActivities, 300);
  }, [activities]);
  
  const collapseAllActivities = () => {
    setActivitiesExpanded([]);
  };

  useEffect(() => {
    if (activitiesExpanded.length === 0) {
      setExpandedAll(false);
    }
    if (activitiesExpanded.length === activities.length) {
      setExpandedAll(true);
    }
  }, [activitiesExpanded]);

  return (
    <>
      <Typography
        variant="h6"
        color="primary"
        mb={4}
        mt={3}
      >
        {t('aprovedStudentSubjects') as string}
      </Typography>
      <Paper variant="outlined" sx={{ width: '100%' }}>
        <TableContainer>
          <Table className="EQXXI-RequestDetail-ActivitiesTable" size="small">
            <TableHead>
              <TableRow>
                <TableCell className="EQXXI-RequestDetail-Name" sx={{ marginLeft: 0 }}>
                  <Box sx={{ display: 'flex' }}>
                    <Tooltip title={expandedAll ? t('collapseAll') as string : t('expandAll') as string}>
                      <Button
                        className={`EQXXI-RequestDetail-Switch ${classNameArrowIcon()}`}
                        onClick={handleChangeExpanded}
                        data-testid={'expendedTable-button'}>
                        <ArrowForwardIosSharp sx={{ fontSize: '0.9rem' }} />
                      </Button>
                    </Tooltip>
                    <Typography>{t('activity') as string}</Typography>
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="EQXXI-Equivalency-TableBody" data-testid="request-activity-table-body" style={{ overflow: 'auto', maxHeight: '390px' }} >
              {activities.map((row: string[], i: number) => (
                <RequestActivityRow
                  key={i}
                  row={row}
                  activitiesExpanded={activitiesExpanded}
                  setActivitiesExpanded={setActivitiesExpanded}
                  activitiesInUse={activities}
                  editFiles={editFiles}
                  addFile={addFile}
                  removeFile={removeFile}
                  isEditFile={isEditFile}
                  getMaxSize={getMaxSize}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer >
      </Paper>
    </>
  );
};

RequestActivitiesTable.propTypes = {
  canChange: PropTypes.bool,
  reset: PropTypes.string
};

export default RequestActivitiesTable;
